import WrapperService from "@/modules/core/services/wrapper-service";

const serviceName = "Registration-Service: "
const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/registration';

export default class RegistrationService {
  static async confirmToken(token, successF, errorF) {
    await WrapperService.get(API_URL + "/confirm/" + token, null, serviceName, successF, errorF);
  }

  static activateProfile(id, token, user, successF, errorF) {
    WrapperService.putWithErrorCause(API_URL + "/activate/" + id + "/" + token, user, serviceName, successF, errorF);
  }

  static async activateProfileWithCustomer(id, token, customerRegistration, successF, errorF) {
    await WrapperService.postWithErrorCause(API_URL + "/activate/" + id + "/" + token + "/customer", customerRegistration, serviceName, successF, errorF);
  }

  static async declineRegistry(id, token, successF, errorF) {
    await WrapperService.deleteWithErrorCause(API_URL + "/decline/" + id + "/" + token, serviceName, successF, errorF);
  }
}